import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Button,
  IconButton
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const CustomFileUploader = ({ open, onClose, onFilesUpload }) => {
  const [files, setFiles] = useState([]);

  const handleFileInput = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles((prev) => [...prev, ...selectedFiles]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prev) => [...prev, ...droppedFiles]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleRemoveFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleUpload = () => {
    onFilesUpload(files);
    onClose();
    setFiles([]);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Upload Files</DialogTitle>
      <DialogContent>
        <Box
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          sx={{
            border: "2px dashed #aaa",
            padding: "20px",
            textAlign: "center",
            borderRadius: "8px",
            mb: 2,
            cursor: "pointer"
          }}
          onClick={() => document.getElementById("fileInput").click()}
        >
          <Typography>
            Drag & drop images here, or click to select files
          </Typography>
          <input
            id="fileInput"
            type="file"
            accept="image/*"
            multiple
            onChange={handleFileInput}
            style={{ display: "none" }}
          />
        </Box>

        {files.length > 0 && (
          <Box display="flex" flexWrap="wrap" gap={2}>
            {files.map((file, index) => (
              <Box
                key={index}
                position="relative"
                width={100}
                height={100}
                border="1px solid #ccc"
                borderRadius="2px"
                overflow="hidden"
              >
                <img
                  src={URL.createObjectURL(file)}
                  alt="preview"
                  width="100%"
                  height="100%"
                  style={{ objectFit: "cover" }}
                />
                <IconButton
                  size="small"
                  onClick={() => handleRemoveFile(index)}
                  sx={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    backgroundColor: "rgba(255,255,255,0.8)"
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            ))}
          </Box>
        )}

        <Box mt={3} textAlign="right">
          <Button onClick={onClose} variant="outlined" sx={{ mr: 1 }}>
            Cancel
          </Button>
          <Button
            onClick={handleUpload}
            variant="contained"
            disabled={files.length === 0}
          >
            Upload
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CustomFileUploader;
